// extracted by mini-css-extract-plugin
export var container = "recipe-search-item-module--container--EohTh";
export var img = "recipe-search-item-module--img--ITyuQ";
export var label = "recipe-search-item-module--label--MADBQ";
export var link = "recipe-search-item-module--link--wN-B6";
export var lock = "recipe-search-item-module--lock--7uG-3";
export var name = "recipe-search-item-module--name--USEf7";
export var nameBox = "recipe-search-item-module--name-box--9VGTb";